import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { useDispatch } from "react-redux";

import { useProfile } from "../Components/Hooks/UserHooks";

import { logoutUser } from "../slices/auth/login/thunk";

const AuthProtected = (props : any) =>{
  const dispatch : any = useDispatch();
  const { userProfile, loading, token, isUser, isAdmin } = useProfile();
  const location = useLocation();
  
  useEffect(() => {
    if (userProfile && !loading && token) {
      setAuthorization(token);
    } else if (!userProfile && loading && !token) {
      dispatch(logoutUser());
    }
  }, [token, userProfile, loading, dispatch]);

  /*
    Navigate is un-auth access protected routes via url
    */

  // 1. Mostrar pantalla de carga durante hidratación inicial para evitar bucle
  if (loading) {
    return <div className="vh-100 d-flex justify-content-center align-items-center">Cargando sesión...</div>;
  }

  // 2. Sin sesión = expulsar al login
  if (!userProfile || !token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // 3. RBAC: Si es únicamente USER (no ADMIN) y trata de salir de /whatsapp, redirigirlo a /whatsapp
  if (isUser && !isAdmin) {
    if (!location.pathname.startsWith("/whatsapp")) {
      return <Navigate to="/whatsapp" replace />;
    }
  }

  return <>{props.children}</>;
};


export default AuthProtected;